// Destination-type buckets driving which mission sections `SidePanel` renders.
export const TRADE_DESTINATION_TYPES = ['marine_port', 'merchant_outpost', 'production']
// Outlaw fences — a DISTINCT set from legal trade (mirrors MarketPrices::
// smuggleDestinationTypes). No honest commerce here; you sell to cutthroats.
export const SMUGGLE_DESTINATION_TYPES = ['pirate_lair']

// Baseline defence danger of an ordinary (anchor) Marine port. Mirrors the
// backend `IslandDefense::MARINE_PORT_BASELINE_DANGER`.
export const MARINE_PORT_BASELINE_DANGER = 8

/**
 * An apex Marine harbor: a Marine port whose danger exceeds the baseline is a
 * fortified WAR CITADEL — a raid target only, never a peaceful trade destination
 * (mirrors backend IslandDefense::isMarineWarCitadel + TradeRunService's guard).
 * Used to hide the Commerce section while keeping the Raid section.
 */
export function isMarineWarCitadel(island: { type: string; npcDanger: number | null }): boolean {
  return island.type === 'marine_port' && (island.npcDanger ?? 0) > MARINE_PORT_BASELINE_DANGER
}
